import {
  isAnaliseRisco,
  isFotoFim,
  isFotoInicio,
  isServiceRow,
} from './nsmpRowTypes';
import { normalizeText } from '../../../../components/v2/selectSearchFilter';

export const SERVICOS_TIPO_CHIPS = {
  SERVICE: 'service',
  FOTO_INICIO: 'fotoInicio',
  FOTO_FIM: 'fotoFim',
  ANALISE: 'analise',
};

export const SERVICOS_PRIORIDADE_CHIPS = {
  E: 'E',
  P1: '1',
  P2: '2',
  P3: '3',
  P4: '4',
};

export const SERVICOS_STATUS_CHIPS = {
  PENDENTE: 'pendente',
  DIGITADA: 'digitada',
};

export const EMPTY_SERVICOS_QUICK_FILTER = {
  search: '',
  tipoChip: null,
  prioridadeChip: null,
  statusChip: null,
};

const TIPO_SERVICO_OPTIONS = [
  { id: 'E', nome: 'E-mail' },
  { id: 'EM', nome: 'Grupo de Emergência' },
  { id: 'L', nome: 'Limpeza de Faixa' },
  { id: 'M', nome: 'Manutenção' },
  { id: 'NC', nome: 'Não Cadastrada' },
  { id: 'OB', nome: 'Objeto na Rede' },
  { id: 'OS', nome: 'OSAF' },
  { id: 'PL', nome: 'Planilha' },
  { id: 'P', nome: 'Poda RDR ou RDU' },
  { id: 'PR', nome: 'Programada' },
  { id: 'FO', nome: 'Fibra Óptica' },
  { id: 'RT', nome: 'Relatório Termográfico' },
  { id: 'AT', nome: 'Análise Termográfico' },
];

const MOTIVO_OPTIONS = [
  { id: 'NCA', nome: 'Anotação Indevida' },
  { id: 'NCD', nome: 'Duplicidade' },
  { id: 'NCP', nome: 'Prioridade' },
  { id: 'NCPL', nome: 'Planilha' },
];

const hasValue = (value) =>
  value != null && String(value).trim() !== '';

export const getTipoServicoLabel = (row) => {
  if (!row?.tipoServico) return '';

  const { tipoServico, motivo, numLinhasPlanilha, quantidadePostes } = row;
  const servico = TIPO_SERVICO_OPTIONS.find((t) => t.id === tipoServico);
  if (!servico) return '';

  const tipoServicoNome = servico.nome;
  if (tipoServico === 'NC') {
    const motivoSelected = MOTIVO_OPTIONS.find((t) => t.id === motivo);
    if (motivoSelected) {
      return `${tipoServicoNome}/${motivoSelected.nome}`;
    }
  } else if (tipoServico === 'PL' && numLinhasPlanilha) {
    return `${tipoServicoNome} - ${numLinhasPlanilha} linha(s)`;
  } else if (tipoServico === 'FO' && quantidadePostes) {
    return `${tipoServicoNome} - ${quantidadePostes} poste(s)`;
  }
  return tipoServicoNome;
};

export const getNsmpRowTitle = (row) => {
  if (!row) return '';
  if (isFotoInicio(row)) return 'Foto Inicial';
  if (isFotoFim(row)) return 'Foto Final';
  if (isAnaliseRisco(row)) return 'Análise de Risco';
  if (row.fotoRegistro) return `Foto Registro ${row.codigo}`;
  return `Serviço ${row.codigo}`;
};

export const getNsmpRowSearchFields = (row) => {
  if (!row) return [];

  return [
    row.codigo,
    getNsmpRowTitle(row),
    row.servico,
    row.tipoServico,
    getTipoServicoLabel(row),
    row.nsmpProgramada,
    row.nsmp,
  ]
    .filter(hasValue)
    .map((v) => String(v));
};

const matchesTipo = (row, tipoChip) => {
  if (!tipoChip) return true;

  switch (tipoChip) {
    case SERVICOS_TIPO_CHIPS.SERVICE:
      return isServiceRow(row);
    case SERVICOS_TIPO_CHIPS.FOTO_INICIO:
      return isFotoInicio(row);
    case SERVICOS_TIPO_CHIPS.FOTO_FIM:
      return isFotoFim(row);
    case SERVICOS_TIPO_CHIPS.ANALISE:
      return isAnaliseRisco(row);
    default:
      return true;
  }
};

const matchesPrioridade = (row, prioridadeChip) => {
  if (!prioridadeChip) return true;
  if (!row.prioridade) return false;

  if (prioridadeChip === SERVICOS_PRIORIDADE_CHIPS.E) {
    return String(row.prioridade).toUpperCase() === 'E';
  }
  return String(row.prioridade) === prioridadeChip;
};

const matchesStatus = (row, statusChip) => {
  if (!statusChip) return true;

  // Status de digitação só se aplica a linhas de serviço (não fotos/análise)
  if (!isServiceRow(row)) return false;

  const hasTipoServico = hasValue(row.tipoServico);

  switch (statusChip) {
    case SERVICOS_STATUS_CHIPS.PENDENTE:
      return !hasTipoServico;
    case SERVICOS_STATUS_CHIPS.DIGITADA:
      return hasTipoServico;
    default:
      return true;
  }
};

const matchesSearch = (row, search) => {
  if (!search || !search.trim()) return true;
  const term = normalizeText(search);
  return getNsmpRowSearchFields(row).some((field) =>
    normalizeText(field).includes(term)
  );
};

export const isServicosFilterActive = (quickFilter) => {
  if (!quickFilter) return false;
  return (
    Boolean(quickFilter.search && quickFilter.search.trim())
    || Boolean(quickFilter.tipoChip)
    || Boolean(quickFilter.prioridadeChip)
    || Boolean(quickFilter.statusChip)
  );
};

export const applyServicosQuickFilters = (rows, quickFilter) => {
  if (!rows) return [];
  if (!isServicosFilterActive(quickFilter)) return rows;

  return rows.filter(
    (row) =>
      matchesTipo(row, quickFilter.tipoChip)
      && matchesPrioridade(row, quickFilter.prioridadeChip)
      && matchesStatus(row, quickFilter.statusChip)
      && matchesSearch(row, quickFilter.search)
  );
};
